'use strict';

require('./chunk-ba04ad2f.js');
var _dropWhile = require('./_dropWhile.js');
var _takeWhile = require('./_takeWhile.js');

function span(p, as) {
  return [_takeWhile(p, as), _dropWhile(p, as)];
}

module.exports = span;
